import { render, staticRenderFns } from "./HandleDetail.vue?vue&type=template&id=640bd318&scoped=true&"
import script from "./HandleDetail.vue?vue&type=script&lang=js&"
export * from "./HandleDetail.vue?vue&type=script&lang=js&"
import style0 from "./HandleDetail.vue?vue&type=style&index=0&id=640bd318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bd318",
  null
  
)

export default component.exports